module.exports = __webpack_public_path__ + "img/nofound.7ddde1df.png";